<template>
    <div>Здесь будет дашборд</div>
</template>

<style>

</style>

<script>
export default {
  name: 'Home',
  created() {
    console.log('Home');
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
